import { updateVehicle } from "../../../store/slices/vehicleSlice";

export default function responseUpdateVehicle(response: any, api: any, arg: any) {
    console.log('update vehicle response', response);
    if (response?.data) {
        api.dispatch(updateVehicle({ id: arg.arguments?.id, data: response.data }));
    }
    return response?.data || null;
}